import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import { grayScale, mHeader1, wHeader2 } from "@teamsparta/design-system";
import { fontPretendard } from "@teamsparta/design-system/dist/font/font";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 360px;
  ${DESKTOP} {
    width: initial;
  }
`;

export const Title = styled.h1`
  ${mHeader1};
  padding: 0 16px;
  ${DESKTOP} {
    ${wHeader2};
    padding: 0;
    text-align: center;
  }
`;

export const ImageContainer = styled.div<{ more: boolean }>`
  position: relative;
  display: grid;
  justify-content: center;
  width: 100%;
  height: ${({ more }) => (more ? "100%" : "144px")};
  overflow: hidden;
  margin-top: 50px;
  ${DESKTOP} {
    height: 100%;
    margin-top: 80px;
  }
`;

export const MobileImageWrapper = styled.div`
  position: relative;
  width: 360px;
  height: 288px;
  ${DESKTOP} {
    display: none;
  }
`;
export const WebImageWrapper = styled.div`
  display: none;
  position: relative;
  ${DESKTOP} {
    width: 1016px;
    height: 210px;
    display: block;
  }
`;

export const Gradation = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  ${DESKTOP} {
    display: none;
  }
`;
export const MoreCta = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
  align-items: center;
  gap: 6px;
  width: 121px;
  height: 47px;
  z-index: 1;
  border: 1px solid ${grayScale.gray20};
  border-radius: 8px;
  cursor: pointer;
  color: ${grayScale.gray90};
  font-family: ${fontPretendard};
  font-weight: 500;
  font-size: 15px;
  line-height: 150%;
  ${DESKTOP} {
    display: none;
  }
`;
